/* Zabi Hair — Inline predictive search (geen paginanavigatie) */
(function () {
  'use strict';

  var DEBOUNCE = 200;
  var LIMIT = 6;

  function money(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(num);
    } catch (e) {
      return '€ ' + num.toFixed(2).replace('.', ',');
    }
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  function initSearch(header) {
    var toggle = header.querySelector('[data-search-toggle]');
    var panel = header.querySelector('[data-search]');
    if (!toggle || !panel || panel.dataset.searchInit) return;
    panel.dataset.searchInit = '1';

    var form = panel.querySelector('.zabi-search__form');
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var closeBtn = panel.querySelector('[data-search-close]');
    var timer = null;
    var controller = null;
    var closeAnim = null;

    /* Scrim over de pagina (licht donker + subtiele blur) terwijl het zoekpaneel open is. */
    if (!document.querySelector('.zabi-search-scrim')) {
      var scrim = document.createElement('div');
      scrim.className = 'zabi-search-scrim';
      scrim.setAttribute('aria-hidden', 'true');
      document.body.appendChild(scrim);
      scrim.addEventListener('click', function () { close(); });
    }

    function open() {
      window.clearTimeout(closeAnim);
      panel.hidden = false;
      document.body.classList.add('zabi-search-open');
      /* volgende frame: is-open toevoegen zodat de fade/slide-in animeert */
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        input.focus();
      });
      toggle.setAttribute('aria-expanded', 'true');
      input.setAttribute('aria-expanded', results.hidden ? 'false' : 'true');
    }
    function close() {
      panel.classList.remove('is-open');
      document.body.classList.remove('zabi-search-open');
      toggle.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-expanded', 'false');
      clearActive();
      /* na de uit-animatie pas display:none zetten */
      window.clearTimeout(closeAnim);
      closeAnim = window.setTimeout(function () { panel.hidden = true; }, 130);
    }
    function isOpen() { return !panel.hidden && panel.classList.contains('is-open'); }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen()) { close(); } else { open(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* ---- Resultaten renderen ---- */
    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(data, query) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var pages = r.pages || [];
      var articles = r.articles || [];
      var html = '';

      if (products.length) {
        html += '<div class="zabi-search__group"><p class="zabi-search__group-label">Producten</p><div class="zabi-search__products">';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var thumb = img
            ? '<span class="zabi-search__thumb"><img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52"></span>'
            : '<span class="zabi-search__thumb"></span>';
          var price = p.price != null ? '<p class="zabi-search__product-price">' + esc(money(p.price)) + '</p>' : '';
          html += '<a class="zabi-search__product" role="option" href="' + esc(p.url) + '">' +
            thumb +
            '<span class="zabi-search__product-text">' +
            '<span class="zabi-search__product-title">' + esc(p.title) + '</span>' +
            price +
            '</span></a>';
        });
        html += '</div></div>';
      }

      var links = [].concat(
        pages.map(function (x) { return { title: x.title, url: x.url }; }),
        articles.map(function (x) { return { title: x.title, url: x.url }; })
      );
      if (links.length) {
        html += '<div class="zabi-search__group"><p class="zabi-search__group-label">Pagina\'s</p><div class="zabi-search__links">';
        links.forEach(function (l) {
          html += '<a class="zabi-search__link" role="option" href="' + esc(l.url) + '">' + esc(l.title) + '</a>';
        });
        html += '</div></div>';
      }

      if (!html) {
        html = '<p class="zabi-search__empty">Geen resultaten voor “' + esc(query) + '”.</p>';
      }

      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function fetchResults(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product,page,article' +
        '&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) { render(data, query); })
        .catch(function (err) { if (err.name !== 'AbortError') clearResults(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      clearActive();
      if (q.length < 2) { clearResults(); return; }
      timer = window.setTimeout(function () { fetchResults(q); }, DEBOUNCE);
    });

    /* ---- Toetsenbord-navigatie ---- */
    function options() { return Array.prototype.slice.call(results.querySelectorAll('[role="option"]')); }
    function clearActive() {
      options().forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
    }
    function move(dir) {
      var opts = options();
      if (!opts.length) return;
      var idx = opts.findIndex(function (o) { return o.classList.contains('is-active'); });
      clearActive();
      idx = (idx + dir + opts.length + (idx === -1 && dir < 0 ? 1 : 0)) % opts.length;
      if (idx < 0) idx = opts.length - 1;
      var el = opts[idx];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      el.scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter') {
        var active = results.querySelector('[role="option"].is-active');
        if (active) { e.preventDefault(); window.location.href = active.getAttribute('href'); }
        /* anders: form submit → volledige /search-pagina */
      }
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); toggle.focus(); }
    });

    /* Klik buiten het paneel sluit */
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (!panel.contains(e.target) && !toggle.contains(e.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('.zabi-header').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
